import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { AngularSvgIconModule } from 'angular-svg-icon';

import { TranslateModule } from '@ngx-translate/core';

interface ErrorDialogInterface {
  icon: string;
  title: string;
  body: string;
}

@Component({
  selector: 'eb-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, TranslateModule, AngularSvgIconModule],
})
export class ErrorDialogComponent {
  readonly data = inject<ErrorDialogInterface>(MAT_DIALOG_DATA);
  private readonly cdr = inject(ChangeDetectorRef);
  readonly dialogRef = inject<MatDialogRef<ErrorDialogComponent>>(MatDialogRef);

  onClose(evt: MouseEvent): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.dialogRef.close(true);
    this.cdr.markForCheck();
  }
}
